/* i18n-disable-file: 表格列定义中 label 使用中文 key，由消费方在模板上调用 $t(column.label) 翻译；render 函数内通过 i18n 实例 t() 翻译 */
import moment from 'moment';
import i18n from '@/i18n';

export const monitorMsgType = {
    0: '未知',
    1: '与客户沟通',
    2: '与同事沟通',
    3: '群内沟通',
};

export const degreeConfig = {
    0: '未知',
    1: '消息拦截',
    2: '仅提示或告警',
    3: '仅留存记录',
    4: '替换型',
};


export const recordsColumns = [
    {
        label: '触发账号',
        columnKey: 'account',
        render(h, props) {
            return (
                <span>{i18n.t('{name}（{id}）', { name: props.row.from?.name || '', id: props.row.from?.uin || '' })}</span>
            );
        },
        width: 230,
    },
    {
        label: '敏感词',
        columnKey: 'matched_words',
        render(h, props) {
            return (
                <div class="records-table__tag">
                    <span>{  props.row.matched_words || '' }</span>
                </div>
            );
        },
        width: 120,
    },
    {
        label: '规则名',
        columnKey: 'ruleName',
        render(h, props) {
            return (
                <span>{ props.row.rule?.name || '' }</span>
            );
        },
    },
    {
        label: '消息内容',
        columnKey: 'message_content',
    },
    {
        label: '监控消息类型',
        columnKey: 'type',
        render(h, props) {
            return (
                <span>{i18n.t(monitorMsgType[props.row.channel])}</span>
            );
        },
        width: 120,
    },
    {
        label: '告警程度',
        columnKey: 'degree',
        render(h, props) {
            return (
                <span>{ i18n.t(degreeConfig[props.row.action || 0]) }</span>
            );
        },
        width: 120,
    },
    {
        label: '消息接收方',
        columnKey: 'receiver',
        render(h, props) {
            return (
                <span>{i18n.t('与{name}（{uin}）的聊天', { name: props.row.to?.name || '', uin: props.row.to?.uin || '' })}</span>
            );
        },
    },
    {
        label: '触发时间',
        columnKey: 'hit_time',
        render(h, props) {
            return (
                <span>{moment(props.row.hit_time * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
            );
        },
    },
];
